import { Link } from 'react-router-dom';
import { Phone, MessageCircle, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

export function CTASection() {
  return (
    <section className="py-20 relative overflow-hidden" data-testid="cta-section">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/2245436/pexels-photo-2245436.png?auto=compress&cs=tinysrgb&w=1920"
          alt="Adventure awaits"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#FF6B35]/90" />
      </div>

      {/* Content */}
      <div className="relative max-w-5xl mx-auto px-4">
        <div className="text-center">
          <span className="inline-block bg-white/20 backdrop-blur-sm text-white text-sm font-medium px-4 py-2 rounded-full mb-6">
            ✈️ Ready for an Adventure?
          </span>
          
          <h2 
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Let&apos;s Plan Your Dream Vacation<br />
            <span className="text-white/90">Together!</span>
          </h2>
          
          <p className="text-white/80 text-lg mb-10 max-w-2xl mx-auto">
            Get personalized travel recommendations and exclusive deals from our expert travel consultants. 
            Your perfect trip is just a call away!
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10">
            <Link to="/contact">
              <Button 
                size="lg" 
                className="bg-white text-[#FF6B35] hover:bg-gray-100 rounded-full px-8 py-6 text-lg font-semibold group"
              >
                Get Free Quote
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
            <a href="https://wa.me/919181268900" target="_blank" rel="noopener noreferrer">
              <Button 
                variant="outline" 
                size="lg" 
                className="border-white text-white hover:bg-white hover:text-[#FF6B35] rounded-full px-8 py-6 text-lg font-semibold"
              >
                <MessageCircle className="mr-2 w-5 h-5" />
                WhatsApp Us
              </Button>
            </a>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-white">
            <a 
              href="tel:+919181268900" 
              className="flex items-center gap-2 hover:text-white/80 transition-colors"
            >
              <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                <Phone className="w-5 h-5" />
              </div>
              <span className="font-semibold">+91 9181268900</span>
            </a>
            <span className="hidden sm:block text-white/50">|</span>
            <div className="flex items-center gap-2">
              <span className="text-white/70">Available</span>
              <span className="bg-green-400 text-green-900 text-xs font-bold px-2 py-1 rounded-full">
                24/7
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
